import createAsyncSlice from "../utils/createAsyncSlice";

const logOrders = createAsyncSlice({
  name: "logOrders",
  initialState: {
    data: [],
  },
});

export const fetchLogOrders = logOrders.asyncAction;
export const { resetState: resetLogOrdersState } = logOrders.actions;
export default logOrders.reducer;
